"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = ["compare_id_count"];
var vue_3 = require("vue");
var vuex_1 = require("vuex");
exports.default = vue_1.defineComponent({
    setup: function (__props) {
        var _this = this;
        var store = vuex_1.useStore();
        vue_3.onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var res, favorite_ids;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        window.lps.emitter.on('addVariantToOrder', function (arr) {
                            store.dispatch('addVariantToOrder', {
                                variant_id: arr[0],
                                count: arr[1],
                                target: arr[2]
                            });
                        });
                        window.lps.emitter.on('changePositionCount', function (arr) {
                            store.dispatch('changePositionCount', {
                                position_id: arr[0],
                                count: arr[1]
                            });
                        });
                        window.lps.emitter.on('delOrderPosition', function (position_id) {
                            store.dispatch('delOrderPosition', {
                                position_id: position_id
                            });
                        });
                        window.lps.emitter.on('clearCart', function (order) {
                            store.dispatch('clearCart', order);
                        });
                        return [4 /*yield*/, store.dispatch('getData')];
                    case 1:
                        res = _d.sent();
                        favorite_ids = (_b = (_a = res.user) === null || _a === void 0 ? void 0 : _a.favorite_ids.reduce(function (obj, i) {
                            obj[i] = i;
                            return obj;
                        }, {})) !== null && _b !== void 0 ? _b : {};
                        window.favorites = favorite_ids;
                        window.updateFavoriteIconNumber();
                        document.querySelectorAll('.add-to-fav-btn').forEach(window.initAddToFavBtn);
                        window.compare = (_c = res.compare_ids) !== null && _c !== void 0 ? _c : {};
                        document.querySelectorAll('.compare-btn').forEach(window.initCompareBtn);
                        window.updateCompareIconNumber(Object.keys(compare).length);
                        return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", {
                compare_id_count: vue_2.unref(store).getters.compare_ids_count
            }, null, 8, _hoisted_1));
        };
    }
});
